/* eslint-disable camelcase */
/* eslint-disable class-methods-use-this */

import { toLower } from 'lodash';
import get from 'lodash/get';
import BasicService from '../Basic/BasicService';

class SequenceSubjectService extends BasicService {
    // 已勾选序列
    selectedObj = {
        isExclude: false,
        excludeSeqs: [],
        slectedSeqs: [],
        selectedCount: 0,
        seqName: '',
    }

    constructor() {
        super();
        this.type = 'BIO';
        this.type_alias = 'bio';
    }

    getFolderIcon() {
        return 'SolidFolderClosed2';
    }

    updateSeqName(val) {
        this.selectedObj.seqName = val;
    }

    getSubmitApiConfig() {
        const { selectedWorkspace: { space_id }, selectedFolder: { folder_id } } = this.folderSelector;
        return {
            url: `${this.baseUrl}/space/${space_id}/folder/${folder_id}/save-common-data`,
            method: 'POST',
        };
    }

    getFolderElementsCountString({ folder }) {
        const { bio_count = 0 } = folder;
        return `(${this.formatNumber(bio_count)})`;
    }

    getWorkspaceElementsCountString(workspace) {
        const { total_bio_count = 0 } = workspace;
        const count = this.formatNumber(total_bio_count);
        return `(${count})`;
    }

    handleJumpToWorkspaceLink({
        folder_id,
        // folder_name,
        space_id,
        source_type,
        data_type,
    }) {
        const defaultWorkspaceViewType = this.type_alias || data_type || this.type || 'PATENT';
        const query = `?spaceId=${space_id}&folderId=${folder_id}&page=1&from=${source_type || ''}`;
        const base = `${this.workspaceProductDomain}/detail/${toLower(defaultWorkspaceViewType)}`;

        return base + query;
    }

    getSearchParams() {
        const params = super.getSearchParams();
        params.need_public_space = false;
        return params;
    }

    getDisabledAllTypeTooltip() {
        if (!this.disabledAllType || this.folderSelector.loading) return '';
        const {
            type, formatNumber, rangeSelector: { maxPerFolder }, vm,
        } = this;
        return vm.$t(
            `BaseSaveToWorkspace.${type}.RangeSelector.error.disabledSelectAllError`,
            { limit: formatNumber(maxPerFolder) },
        );
    }

    initFolderSelector() {
        this
            .fetchWorkspaces()
            .then(() => {
                if (!this.folderSelector.response) return;
                const addLimit = get(this.folderSelector, 'response.addLimit');
                const maxPerFolder = get(this.folderSelector, 'response.maxPerFolder');

                this.rangeSelector.addLimit = addLimit;
                this.rangeSelector.maxPerFolder = maxPerFolder;
                this.rangeSelector.disabledTypes = [];
                const {
                    maxInputLimit, allCounts,
                } = this.rangeSelector;

                this.rangeSelector.countMax = allCounts;
                if (allCounts > maxPerFolder) {
                    this.rangeSelector.selectedType = 'RANGE';
                    this.rangeSelector.disabledTypes = ['ALL'];
                }

                this.rangeSelector.max = Math.min(this.rangeSelector.countMax, maxInputLimit, addLimit);

                this.rangeSelector.to = this.rangeSelector.max;

                this.verifyRange();
            });
    }

    init() {
        this.initFolderSelector();
    }
}

export default SequenceSubjectService;
